export default "__VITE_ASSET__CF0hmPrv__"